import { AccountKey, ConfirmationsKey, ConfirmationsParamKey, Sort } from './types';

export const makeConfirmationsKey = (accountNo: AccountKey, from: Date | number, to: Date | number) => `${accountNo}_${from.valueOf()}_${to.valueOf()}`;

export const makeConfirmationsSubscriptionKey = (accountNo: AccountKey, from: Date | number, to: Date | number) =>
  JSON.stringify({ accountNo, from: from.valueOf(), to: to.valueOf() } as ConfirmationsKey);

export const makeConfirmationsParamKey = (pageSize: number, sortColumn: string, sortDirection: Sort) => `${pageSize}_${sortColumn}_${sortDirection}`;

export const makeConfirmationsParamSubscriptionKey = (
  accountNo: AccountKey,
  from: Date | number,
  to: Date | number,
  pageSize: number,
  sortColumn: string,
  sortDirection: Sort,
  page: number
) => JSON.stringify({ accountNo, from: from.valueOf(), to: to.valueOf(), pageSize, sortColumn, sortDirection, page } as ConfirmationsParamKey);
